// AUTO-GENERATED by scripts/generate-raster-image-sets.mjs — do not edit manually.

export interface RasterImageSet {
  id: string;
  width: number;
  height: number;
  avifSrcSet: string;
  webpSrcSet: string;
  fallback: string;
  lcpAvif: string;
}

import meta_air_source_heat_pumps_ashp_card_cylinder from "@/assets/air-source-heat-pumps/ashp-card-cylinder.jpg?as=metadata";
import avif_air_source_heat_pumps_ashp_card_cylinder from "@/assets/air-source-heat-pumps/ashp-card-cylinder.jpg?w=640;1024;1920&format=avif&as=srcset";
import webp_air_source_heat_pumps_ashp_card_cylinder from "@/assets/air-source-heat-pumps/ashp-card-cylinder.jpg?w=640;1024;1920&format=webp&as=srcset";
import fallback_air_source_heat_pumps_ashp_card_cylinder from "@/assets/air-source-heat-pumps/ashp-card-cylinder.jpg?w=1920&format=webp";
import lcp_air_source_heat_pumps_ashp_card_cylinder from "@/assets/air-source-heat-pumps/ashp-card-cylinder.jpg?w=1920&format=avif";

import meta_air_source_heat_pumps_ashp_card_electrics from "@/assets/air-source-heat-pumps/ashp-card-electrics.jpg?as=metadata";
import avif_air_source_heat_pumps_ashp_card_electrics from "@/assets/air-source-heat-pumps/ashp-card-electrics.jpg?w=640;1024;1920&format=avif&as=srcset";
import webp_air_source_heat_pumps_ashp_card_electrics from "@/assets/air-source-heat-pumps/ashp-card-electrics.jpg?w=640;1024;1920&format=webp&as=srcset";
import fallback_air_source_heat_pumps_ashp_card_electrics from "@/assets/air-source-heat-pumps/ashp-card-electrics.jpg?w=1920&format=webp";
import lcp_air_source_heat_pumps_ashp_card_electrics from "@/assets/air-source-heat-pumps/ashp-card-electrics.jpg?w=1920&format=avif";

import meta_air_source_heat_pumps_ashp_card_emitters from "@/assets/air-source-heat-pumps/ashp-card-emitters.jpg?as=metadata";
import avif_air_source_heat_pumps_ashp_card_emitters from "@/assets/air-source-heat-pumps/ashp-card-emitters.jpg?w=640;1024;1920&format=avif&as=srcset";
import webp_air_source_heat_pumps_ashp_card_emitters from "@/assets/air-source-heat-pumps/ashp-card-emitters.jpg?w=640;1024;1920&format=webp&as=srcset";
import fallback_air_source_heat_pumps_ashp_card_emitters from "@/assets/air-source-heat-pumps/ashp-card-emitters.jpg?w=1920&format=webp";
import lcp_air_source_heat_pumps_ashp_card_emitters from "@/assets/air-source-heat-pumps/ashp-card-emitters.jpg?w=1920&format=avif";

import meta_air_source_heat_pumps_ashp_card_fabric from "@/assets/air-source-heat-pumps/ashp-card-fabric.jpg?as=metadata";
import avif_air_source_heat_pumps_ashp_card_fabric from "@/assets/air-source-heat-pumps/ashp-card-fabric.jpg?w=640;1024;1920&format=avif&as=srcset";
import webp_air_source_heat_pumps_ashp_card_fabric from "@/assets/air-source-heat-pumps/ashp-card-fabric.jpg?w=640;1024;1920&format=webp&as=srcset";
import fallback_air_source_heat_pumps_ashp_card_fabric from "@/assets/air-source-heat-pumps/ashp-card-fabric.jpg?w=1920&format=webp";
import lcp_air_source_heat_pumps_ashp_card_fabric from "@/assets/air-source-heat-pumps/ashp-card-fabric.jpg?w=1920&format=avif";

import meta_air_source_heat_pumps_ashp_card_heatloss from "@/assets/air-source-heat-pumps/ashp-card-heatloss.jpg?as=metadata";
import avif_air_source_heat_pumps_ashp_card_heatloss from "@/assets/air-source-heat-pumps/ashp-card-heatloss.jpg?w=640;1024;1920&format=avif&as=srcset";
import webp_air_source_heat_pumps_ashp_card_heatloss from "@/assets/air-source-heat-pumps/ashp-card-heatloss.jpg?w=640;1024;1920&format=webp&as=srcset";
import fallback_air_source_heat_pumps_ashp_card_heatloss from "@/assets/air-source-heat-pumps/ashp-card-heatloss.jpg?w=1920&format=webp";
import lcp_air_source_heat_pumps_ashp_card_heatloss from "@/assets/air-source-heat-pumps/ashp-card-heatloss.jpg?w=1920&format=avif";

import meta_air_source_heat_pumps_ashp_card_siting from "@/assets/air-source-heat-pumps/ashp-card-siting.jpg?as=metadata";
import avif_air_source_heat_pumps_ashp_card_siting from "@/assets/air-source-heat-pumps/ashp-card-siting.jpg?w=640;1024;1920&format=avif&as=srcset";
import webp_air_source_heat_pumps_ashp_card_siting from "@/assets/air-source-heat-pumps/ashp-card-siting.jpg?w=640;1024;1920&format=webp&as=srcset";
import fallback_air_source_heat_pumps_ashp_card_siting from "@/assets/air-source-heat-pumps/ashp-card-siting.jpg?w=1920&format=webp";
import lcp_air_source_heat_pumps_ashp_card_siting from "@/assets/air-source-heat-pumps/ashp-card-siting.jpg?w=1920&format=avif";

import meta_air_source_heat_pumps_ashp_evidence from "@/assets/air-source-heat-pumps/ashp-evidence.jpg?as=metadata";
import avif_air_source_heat_pumps_ashp_evidence from "@/assets/air-source-heat-pumps/ashp-evidence.jpg?w=640;1024;1920&format=avif&as=srcset";
import webp_air_source_heat_pumps_ashp_evidence from "@/assets/air-source-heat-pumps/ashp-evidence.jpg?w=640;1024;1920&format=webp&as=srcset";
import fallback_air_source_heat_pumps_ashp_evidence from "@/assets/air-source-heat-pumps/ashp-evidence.jpg?w=1920&format=webp";
import lcp_air_source_heat_pumps_ashp_evidence from "@/assets/air-source-heat-pumps/ashp-evidence.jpg?w=1920&format=avif";

import meta_air_source_heat_pumps_ashp_handover_pack from "@/assets/air-source-heat-pumps/ashp-handover-pack.jpg?as=metadata";
import avif_air_source_heat_pumps_ashp_handover_pack from "@/assets/air-source-heat-pumps/ashp-handover-pack.jpg?w=640;1024;1920&format=avif&as=srcset";
import webp_air_source_heat_pumps_ashp_handover_pack from "@/assets/air-source-heat-pumps/ashp-handover-pack.jpg?w=640;1024;1920&format=webp&as=srcset";
import fallback_air_source_heat_pumps_ashp_handover_pack from "@/assets/air-source-heat-pumps/ashp-handover-pack.jpg?w=1920&format=webp";
import lcp_air_source_heat_pumps_ashp_handover_pack from "@/assets/air-source-heat-pumps/ashp-handover-pack.jpg?w=1920&format=avif";

import meta_air_source_heat_pumps_ashp_step_1 from "@/assets/air-source-heat-pumps/ashp-step-1.jpg?as=metadata";
import avif_air_source_heat_pumps_ashp_step_1 from "@/assets/air-source-heat-pumps/ashp-step-1.jpg?w=640;1024;1920&format=avif&as=srcset";
import webp_air_source_heat_pumps_ashp_step_1 from "@/assets/air-source-heat-pumps/ashp-step-1.jpg?w=640;1024;1920&format=webp&as=srcset";
import fallback_air_source_heat_pumps_ashp_step_1 from "@/assets/air-source-heat-pumps/ashp-step-1.jpg?w=1920&format=webp";
import lcp_air_source_heat_pumps_ashp_step_1 from "@/assets/air-source-heat-pumps/ashp-step-1.jpg?w=1920&format=avif";

import meta_air_source_heat_pumps_ashp_step_2 from "@/assets/air-source-heat-pumps/ashp-step-2.jpg?as=metadata";
import avif_air_source_heat_pumps_ashp_step_2 from "@/assets/air-source-heat-pumps/ashp-step-2.jpg?w=640;1024;1920&format=avif&as=srcset";
import webp_air_source_heat_pumps_ashp_step_2 from "@/assets/air-source-heat-pumps/ashp-step-2.jpg?w=640;1024;1920&format=webp&as=srcset";
import fallback_air_source_heat_pumps_ashp_step_2 from "@/assets/air-source-heat-pumps/ashp-step-2.jpg?w=1920&format=webp";
import lcp_air_source_heat_pumps_ashp_step_2 from "@/assets/air-source-heat-pumps/ashp-step-2.jpg?w=1920&format=avif";

import meta_air_source_heat_pumps_ashp_step_3 from "@/assets/air-source-heat-pumps/ashp-step-3.jpg?as=metadata";
import avif_air_source_heat_pumps_ashp_step_3 from "@/assets/air-source-heat-pumps/ashp-step-3.jpg?w=640;1024;1920&format=avif&as=srcset";
import webp_air_source_heat_pumps_ashp_step_3 from "@/assets/air-source-heat-pumps/ashp-step-3.jpg?w=640;1024;1920&format=webp&as=srcset";
import fallback_air_source_heat_pumps_ashp_step_3 from "@/assets/air-source-heat-pumps/ashp-step-3.jpg?w=1920&format=webp";
import lcp_air_source_heat_pumps_ashp_step_3 from "@/assets/air-source-heat-pumps/ashp-step-3.jpg?w=1920&format=avif";

import meta_air_source_heat_pumps_ashp_step_4 from "@/assets/air-source-heat-pumps/ashp-step-4.jpg?as=metadata";
import avif_air_source_heat_pumps_ashp_step_4 from "@/assets/air-source-heat-pumps/ashp-step-4.jpg?w=640;1024;1920&format=avif&as=srcset";
import webp_air_source_heat_pumps_ashp_step_4 from "@/assets/air-source-heat-pumps/ashp-step-4.jpg?w=640;1024;1920&format=webp&as=srcset";
import fallback_air_source_heat_pumps_ashp_step_4 from "@/assets/air-source-heat-pumps/ashp-step-4.jpg?w=1920&format=webp";
import lcp_air_source_heat_pumps_ashp_step_4 from "@/assets/air-source-heat-pumps/ashp-step-4.jpg?w=1920&format=avif";

import meta_boiler_upgrade_scheme_bus_grant_journey from "@/assets/boiler-upgrade-scheme/bus-grant-journey.png?as=metadata";
import avif_boiler_upgrade_scheme_bus_grant_journey from "@/assets/boiler-upgrade-scheme/bus-grant-journey.png?w=640;1024;1920&format=avif&as=srcset";
import webp_boiler_upgrade_scheme_bus_grant_journey from "@/assets/boiler-upgrade-scheme/bus-grant-journey.png?w=640;1024;1920&format=webp&as=srcset";
import fallback_boiler_upgrade_scheme_bus_grant_journey from "@/assets/boiler-upgrade-scheme/bus-grant-journey.png?w=1920&format=webp";
import lcp_boiler_upgrade_scheme_bus_grant_journey from "@/assets/boiler-upgrade-scheme/bus-grant-journey.png?w=1920&format=avif";

import meta_brands_hgc_logo from "@/assets/brands/hgc-logo.png?as=metadata";
import avif_brands_hgc_logo from "@/assets/brands/hgc-logo.png?w=640;1024;1920&format=avif&as=srcset";
import webp_brands_hgc_logo from "@/assets/brands/hgc-logo.png?w=640;1024;1920&format=webp&as=srcset";
import fallback_brands_hgc_logo from "@/assets/brands/hgc-logo.png?w=1920&format=webp";
import lcp_brands_hgc_logo from "@/assets/brands/hgc-logo.png?w=1920&format=avif";

import meta_commercial_damp_mould_ventilation_hero_commercial_damp_mould from "@/assets/commercial-damp-mould-ventilation/hero-commercial-damp-mould.jpg?as=metadata";
import avif_commercial_damp_mould_ventilation_hero_commercial_damp_mould from "@/assets/commercial-damp-mould-ventilation/hero-commercial-damp-mould.jpg?w=640;1024;1920&format=avif&as=srcset";
import webp_commercial_damp_mould_ventilation_hero_commercial_damp_mould from "@/assets/commercial-damp-mould-ventilation/hero-commercial-damp-mould.jpg?w=640;1024;1920&format=webp&as=srcset";
import fallback_commercial_damp_mould_ventilation_hero_commercial_damp_mould from "@/assets/commercial-damp-mould-ventilation/hero-commercial-damp-mould.jpg?w=1920&format=webp";
import lcp_commercial_damp_mould_ventilation_hero_commercial_damp_mould from "@/assets/commercial-damp-mould-ventilation/hero-commercial-damp-mould.jpg?w=1920&format=avif";

import meta_commercial_solar_pv_hero_commercial_solar from "@/assets/commercial-solar-pv/hero-commercial-solar.jpg?as=metadata";
import avif_commercial_solar_pv_hero_commercial_solar from "@/assets/commercial-solar-pv/hero-commercial-solar.jpg?w=640;1024;1920&format=avif&as=srcset";
import webp_commercial_solar_pv_hero_commercial_solar from "@/assets/commercial-solar-pv/hero-commercial-solar.jpg?w=640;1024;1920&format=webp&as=srcset";
import fallback_commercial_solar_pv_hero_commercial_solar from "@/assets/commercial-solar-pv/hero-commercial-solar.jpg?w=1920&format=webp";
import lcp_commercial_solar_pv_hero_commercial_solar from "@/assets/commercial-solar-pv/hero-commercial-solar.jpg?w=1920&format=avif";

import meta_damp_survey_damp_condensation from "@/assets/damp-survey/damp-condensation.jpg?as=metadata";
import avif_damp_survey_damp_condensation from "@/assets/damp-survey/damp-condensation.jpg?w=640;1024;1920&format=avif&as=srcset";
import webp_damp_survey_damp_condensation from "@/assets/damp-survey/damp-condensation.jpg?w=640;1024;1920&format=webp&as=srcset";
import fallback_damp_survey_damp_condensation from "@/assets/damp-survey/damp-condensation.jpg?w=1920&format=webp";
import lcp_damp_survey_damp_condensation from "@/assets/damp-survey/damp-condensation.jpg?w=1920&format=avif";

import meta_damp_survey_damp_penetrating from "@/assets/damp-survey/damp-penetrating.jpg?as=metadata";
import avif_damp_survey_damp_penetrating from "@/assets/damp-survey/damp-penetrating.jpg?w=640;1024;1920&format=avif&as=srcset";
import webp_damp_survey_damp_penetrating from "@/assets/damp-survey/damp-penetrating.jpg?w=640;1024;1920&format=webp&as=srcset";
import fallback_damp_survey_damp_penetrating from "@/assets/damp-survey/damp-penetrating.jpg?w=1920&format=webp";
import lcp_damp_survey_damp_penetrating from "@/assets/damp-survey/damp-penetrating.jpg?w=1920&format=avif";

import meta_damp_survey_damp_rising from "@/assets/damp-survey/damp-rising.jpg?as=metadata";
import avif_damp_survey_damp_rising from "@/assets/damp-survey/damp-rising.jpg?w=640;1024;1920&format=avif&as=srcset";
import webp_damp_survey_damp_rising from "@/assets/damp-survey/damp-rising.jpg?w=640;1024;1920&format=webp&as=srcset";
import fallback_damp_survey_damp_rising from "@/assets/damp-survey/damp-rising.jpg?w=1920&format=webp";
import lcp_damp_survey_damp_rising from "@/assets/damp-survey/damp-rising.jpg?w=1920&format=avif";

import meta_damp_survey_services_breathable_wall_moisture_control from "@/assets/damp-survey/services/breathable-wall-moisture-control.png?as=metadata";
import avif_damp_survey_services_breathable_wall_moisture_control from "@/assets/damp-survey/services/breathable-wall-moisture-control.png?w=640;1024;1920&format=avif&as=srcset";
import webp_damp_survey_services_breathable_wall_moisture_control from "@/assets/damp-survey/services/breathable-wall-moisture-control.png?w=640;1024;1920&format=webp&as=srcset";
import fallback_damp_survey_services_breathable_wall_moisture_control from "@/assets/damp-survey/services/breathable-wall-moisture-control.png?w=1920&format=webp";
import lcp_damp_survey_services_breathable_wall_moisture_control from "@/assets/damp-survey/services/breathable-wall-moisture-control.png?w=1920&format=avif";

import meta_damp_survey_services_cavity_insulation_assessment from "@/assets/damp-survey/services/cavity-insulation-assessment.png?as=metadata";
import avif_damp_survey_services_cavity_insulation_assessment from "@/assets/damp-survey/services/cavity-insulation-assessment.png?w=640;1024;1920&format=avif&as=srcset";
import webp_damp_survey_services_cavity_insulation_assessment from "@/assets/damp-survey/services/cavity-insulation-assessment.png?w=640;1024;1920&format=webp&as=srcset";
import fallback_damp_survey_services_cavity_insulation_assessment from "@/assets/damp-survey/services/cavity-insulation-assessment.png?w=1920&format=webp";
import lcp_damp_survey_services_cavity_insulation_assessment from "@/assets/damp-survey/services/cavity-insulation-assessment.png?w=1920&format=avif";

import meta_damp_survey_services_controlled_ventilation_air_quality from "@/assets/damp-survey/services/controlled-ventilation-air-quality.png?as=metadata";
import avif_damp_survey_services_controlled_ventilation_air_quality from "@/assets/damp-survey/services/controlled-ventilation-air-quality.png?w=640;1024;1920&format=avif&as=srcset";
import webp_damp_survey_services_controlled_ventilation_air_quality from "@/assets/damp-survey/services/controlled-ventilation-air-quality.png?w=640;1024;1920&format=webp&as=srcset";
import fallback_damp_survey_services_controlled_ventilation_air_quality from "@/assets/damp-survey/services/controlled-ventilation-air-quality.png?w=1920&format=webp";
import lcp_damp_survey_services_controlled_ventilation_air_quality from "@/assets/damp-survey/services/controlled-ventilation-air-quality.png?w=1920&format=avif";

import meta_damp_survey_services_external_repairs_management from "@/assets/damp-survey/services/external-repairs-management.png?as=metadata";
import avif_damp_survey_services_external_repairs_management from "@/assets/damp-survey/services/external-repairs-management.png?w=640;1024;1920&format=avif&as=srcset";
import webp_damp_survey_services_external_repairs_management from "@/assets/damp-survey/services/external-repairs-management.png?w=640;1024;1920&format=webp&as=srcset";
import fallback_damp_survey_services_external_repairs_management from "@/assets/damp-survey/services/external-repairs-management.png?w=1920&format=webp";
import lcp_damp_survey_services_external_repairs_management from "@/assets/damp-survey/services/external-repairs-management.png?w=1920&format=avif";

import meta_damp_survey_services_structural_penetrating_damp from "@/assets/damp-survey/services/structural-penetrating-damp.png?as=metadata";
import avif_damp_survey_services_structural_penetrating_damp from "@/assets/damp-survey/services/structural-penetrating-damp.png?w=640;1024;1920&format=avif&as=srcset";
import webp_damp_survey_services_structural_penetrating_damp from "@/assets/damp-survey/services/structural-penetrating-damp.png?w=640;1024;1920&format=webp&as=srcset";
import fallback_damp_survey_services_structural_penetrating_damp from "@/assets/damp-survey/services/structural-penetrating-damp.png?w=1920&format=webp";
import lcp_damp_survey_services_structural_penetrating_damp from "@/assets/damp-survey/services/structural-penetrating-damp.png?w=1920&format=avif";

import meta_financing_ideal4finance_partner_banner from "@/assets/financing/ideal4finance-partner-banner.png?as=metadata";
import avif_financing_ideal4finance_partner_banner from "@/assets/financing/ideal4finance-partner-banner.png?w=640;1024;1920&format=avif&as=srcset";
import webp_financing_ideal4finance_partner_banner from "@/assets/financing/ideal4finance-partner-banner.png?w=640;1024;1920&format=webp&as=srcset";
import fallback_financing_ideal4finance_partner_banner from "@/assets/financing/ideal4finance-partner-banner.png?w=1920&format=webp";
import lcp_financing_ideal4finance_partner_banner from "@/assets/financing/ideal4finance-partner-banner.png?w=1920&format=avif";

import meta_solar_pv_hero_solar from "@/assets/solar-pv/hero-solar.jpg?as=metadata";
import avif_solar_pv_hero_solar from "@/assets/solar-pv/hero-solar.jpg?w=640;1024;1920&format=avif&as=srcset";
import webp_solar_pv_hero_solar from "@/assets/solar-pv/hero-solar.jpg?w=640;1024;1920&format=webp&as=srcset";
import fallback_solar_pv_hero_solar from "@/assets/solar-pv/hero-solar.jpg?w=1920&format=webp";
import lcp_solar_pv_hero_solar from "@/assets/solar-pv/hero-solar.jpg?w=1920&format=avif";

import meta_solar_pv_solar_assessment_roof from "@/assets/solar-pv/solar-assessment-roof.png?as=metadata";
import avif_solar_pv_solar_assessment_roof from "@/assets/solar-pv/solar-assessment-roof.png?w=640;1024;1920&format=avif&as=srcset";
import webp_solar_pv_solar_assessment_roof from "@/assets/solar-pv/solar-assessment-roof.png?w=640;1024;1920&format=webp&as=srcset";
import fallback_solar_pv_solar_assessment_roof from "@/assets/solar-pv/solar-assessment-roof.png?w=1920&format=webp";
import lcp_solar_pv_solar_assessment_roof from "@/assets/solar-pv/solar-assessment-roof.png?w=1920&format=avif";

import meta_solar_pv_solar_card_battery from "@/assets/solar-pv/solar-card-battery.jpg?as=metadata";
import avif_solar_pv_solar_card_battery from "@/assets/solar-pv/solar-card-battery.jpg?w=640;1024;1920&format=avif&as=srcset";
import webp_solar_pv_solar_card_battery from "@/assets/solar-pv/solar-card-battery.jpg?w=640;1024;1920&format=webp&as=srcset";
import fallback_solar_pv_solar_card_battery from "@/assets/solar-pv/solar-card-battery.jpg?w=1920&format=webp";
import lcp_solar_pv_solar_card_battery from "@/assets/solar-pv/solar-card-battery.jpg?w=1920&format=avif";

import meta_solar_pv_solar_card_dno from "@/assets/solar-pv/solar-card-dno.jpg?as=metadata";
import avif_solar_pv_solar_card_dno from "@/assets/solar-pv/solar-card-dno.jpg?w=640;1024;1920&format=avif&as=srcset";
import webp_solar_pv_solar_card_dno from "@/assets/solar-pv/solar-card-dno.jpg?w=640;1024;1920&format=webp&as=srcset";
import fallback_solar_pv_solar_card_dno from "@/assets/solar-pv/solar-card-dno.jpg?w=1920&format=webp";
import lcp_solar_pv_solar_card_dno from "@/assets/solar-pv/solar-card-dno.jpg?w=1920&format=avif";

import meta_solar_pv_solar_card_electrics from "@/assets/solar-pv/solar-card-electrics.jpg?as=metadata";
import avif_solar_pv_solar_card_electrics from "@/assets/solar-pv/solar-card-electrics.jpg?w=640;1024;1920&format=avif&as=srcset";
import webp_solar_pv_solar_card_electrics from "@/assets/solar-pv/solar-card-electrics.jpg?w=640;1024;1920&format=webp&as=srcset";
import fallback_solar_pv_solar_card_electrics from "@/assets/solar-pv/solar-card-electrics.jpg?w=1920&format=webp";
import lcp_solar_pv_solar_card_electrics from "@/assets/solar-pv/solar-card-electrics.jpg?w=1920&format=avif";

import meta_solar_pv_solar_card_monitoring from "@/assets/solar-pv/solar-card-monitoring.jpg?as=metadata";
import avif_solar_pv_solar_card_monitoring from "@/assets/solar-pv/solar-card-monitoring.jpg?w=640;1024;1920&format=avif&as=srcset";
import webp_solar_pv_solar_card_monitoring from "@/assets/solar-pv/solar-card-monitoring.jpg?w=640;1024;1920&format=webp&as=srcset";
import fallback_solar_pv_solar_card_monitoring from "@/assets/solar-pv/solar-card-monitoring.jpg?w=1920&format=webp";
import lcp_solar_pv_solar_card_monitoring from "@/assets/solar-pv/solar-card-monitoring.jpg?w=1920&format=avif";

import meta_solar_pv_solar_card_orientation from "@/assets/solar-pv/solar-card-orientation.jpg?as=metadata";
import avif_solar_pv_solar_card_orientation from "@/assets/solar-pv/solar-card-orientation.jpg?w=640;1024;1920&format=avif&as=srcset";
import webp_solar_pv_solar_card_orientation from "@/assets/solar-pv/solar-card-orientation.jpg?w=640;1024;1920&format=webp&as=srcset";
import fallback_solar_pv_solar_card_orientation from "@/assets/solar-pv/solar-card-orientation.jpg?w=1920&format=webp";
import lcp_solar_pv_solar_card_orientation from "@/assets/solar-pv/solar-card-orientation.jpg?w=1920&format=avif";

import meta_solar_pv_solar_card_roof from "@/assets/solar-pv/solar-card-roof.jpg?as=metadata";
import avif_solar_pv_solar_card_roof from "@/assets/solar-pv/solar-card-roof.jpg?w=640;1024;1920&format=avif&as=srcset";
import webp_solar_pv_solar_card_roof from "@/assets/solar-pv/solar-card-roof.jpg?w=640;1024;1920&format=webp&as=srcset";
import fallback_solar_pv_solar_card_roof from "@/assets/solar-pv/solar-card-roof.jpg?w=1920&format=webp";
import lcp_solar_pv_solar_card_roof from "@/assets/solar-pv/solar-card-roof.jpg?w=1920&format=avif";

import meta_solar_pv_solar_evidence from "@/assets/solar-pv/solar-evidence.jpg?as=metadata";
import avif_solar_pv_solar_evidence from "@/assets/solar-pv/solar-evidence.jpg?w=640;1024;1920&format=avif&as=srcset";
import webp_solar_pv_solar_evidence from "@/assets/solar-pv/solar-evidence.jpg?w=640;1024;1920&format=webp&as=srcset";
import fallback_solar_pv_solar_evidence from "@/assets/solar-pv/solar-evidence.jpg?w=1920&format=webp";
import lcp_solar_pv_solar_evidence from "@/assets/solar-pv/solar-evidence.jpg?w=1920&format=avif";

import meta_solar_pv_solar_handover_pack from "@/assets/solar-pv/solar-handover-pack.jpg?as=metadata";
import avif_solar_pv_solar_handover_pack from "@/assets/solar-pv/solar-handover-pack.jpg?w=640;1024;1920&format=avif&as=srcset";
import webp_solar_pv_solar_handover_pack from "@/assets/solar-pv/solar-handover-pack.jpg?w=640;1024;1920&format=webp&as=srcset";
import fallback_solar_pv_solar_handover_pack from "@/assets/solar-pv/solar-handover-pack.jpg?w=1920&format=webp";
import lcp_solar_pv_solar_handover_pack from "@/assets/solar-pv/solar-handover-pack.jpg?w=1920&format=avif";

import meta_solar_pv_solar_step_1 from "@/assets/solar-pv/solar-step-1.jpg?as=metadata";
import avif_solar_pv_solar_step_1 from "@/assets/solar-pv/solar-step-1.jpg?w=640;1024;1920&format=avif&as=srcset";
import webp_solar_pv_solar_step_1 from "@/assets/solar-pv/solar-step-1.jpg?w=640;1024;1920&format=webp&as=srcset";
import fallback_solar_pv_solar_step_1 from "@/assets/solar-pv/solar-step-1.jpg?w=1920&format=webp";
import lcp_solar_pv_solar_step_1 from "@/assets/solar-pv/solar-step-1.jpg?w=1920&format=avif";

import meta_solar_pv_solar_step_2 from "@/assets/solar-pv/solar-step-2.jpg?as=metadata";
import avif_solar_pv_solar_step_2 from "@/assets/solar-pv/solar-step-2.jpg?w=640;1024;1920&format=avif&as=srcset";
import webp_solar_pv_solar_step_2 from "@/assets/solar-pv/solar-step-2.jpg?w=640;1024;1920&format=webp&as=srcset";
import fallback_solar_pv_solar_step_2 from "@/assets/solar-pv/solar-step-2.jpg?w=1920&format=webp";
import lcp_solar_pv_solar_step_2 from "@/assets/solar-pv/solar-step-2.jpg?w=1920&format=avif";

import meta_solar_pv_solar_step_3 from "@/assets/solar-pv/solar-step-3.jpg?as=metadata";
import avif_solar_pv_solar_step_3 from "@/assets/solar-pv/solar-step-3.jpg?w=640;1024;1920&format=avif&as=srcset";
import webp_solar_pv_solar_step_3 from "@/assets/solar-pv/solar-step-3.jpg?w=640;1024;1920&format=webp&as=srcset";
import fallback_solar_pv_solar_step_3 from "@/assets/solar-pv/solar-step-3.jpg?w=1920&format=webp";
import lcp_solar_pv_solar_step_3 from "@/assets/solar-pv/solar-step-3.jpg?w=1920&format=avif";

import meta_solar_pv_why_battery from "@/assets/solar-pv/why-battery.jpg?as=metadata";
import avif_solar_pv_why_battery from "@/assets/solar-pv/why-battery.jpg?w=640;1024;1920&format=avif&as=srcset";
import webp_solar_pv_why_battery from "@/assets/solar-pv/why-battery.jpg?w=640;1024;1920&format=webp&as=srcset";
import fallback_solar_pv_why_battery from "@/assets/solar-pv/why-battery.jpg?w=1920&format=webp";
import lcp_solar_pv_why_battery from "@/assets/solar-pv/why-battery.jpg?w=1920&format=avif";

import meta_solar_pv_why_designed_customer from "@/assets/solar-pv/why-designed-customer.jpg?as=metadata";
import avif_solar_pv_why_designed_customer from "@/assets/solar-pv/why-designed-customer.jpg?w=640;1024;1920&format=avif&as=srcset";
import webp_solar_pv_why_designed_customer from "@/assets/solar-pv/why-designed-customer.jpg?w=640;1024;1920&format=webp&as=srcset";
import fallback_solar_pv_why_designed_customer from "@/assets/solar-pv/why-designed-customer.jpg?w=1920&format=webp";
import lcp_solar_pv_why_designed_customer from "@/assets/solar-pv/why-designed-customer.jpg?w=1920&format=avif";

import meta_solar_pv_why_designed from "@/assets/solar-pv/why-designed.jpg?as=metadata";
import avif_solar_pv_why_designed from "@/assets/solar-pv/why-designed.jpg?w=640;1024;1920&format=avif&as=srcset";
import webp_solar_pv_why_designed from "@/assets/solar-pv/why-designed.jpg?w=640;1024;1920&format=webp&as=srcset";
import fallback_solar_pv_why_designed from "@/assets/solar-pv/why-designed.jpg?w=1920&format=webp";
import lcp_solar_pv_why_designed from "@/assets/solar-pv/why-designed.jpg?w=1920&format=avif";

import meta_solar_pv_why_export from "@/assets/solar-pv/why-export.jpg?as=metadata";
import avif_solar_pv_why_export from "@/assets/solar-pv/why-export.jpg?w=640;1024;1920&format=avif&as=srcset";
import webp_solar_pv_why_export from "@/assets/solar-pv/why-export.jpg?w=640;1024;1920&format=webp&as=srcset";
import fallback_solar_pv_why_export from "@/assets/solar-pv/why-export.jpg?w=1920&format=webp";
import lcp_solar_pv_why_export from "@/assets/solar-pv/why-export.jpg?w=1920&format=avif";

import meta_solar_pv_why_generate from "@/assets/solar-pv/why-generate.jpg?as=metadata";
import avif_solar_pv_why_generate from "@/assets/solar-pv/why-generate.jpg?w=640;1024;1920&format=avif&as=srcset";
import webp_solar_pv_why_generate from "@/assets/solar-pv/why-generate.jpg?w=640;1024;1920&format=webp&as=srcset";
import fallback_solar_pv_why_generate from "@/assets/solar-pv/why-generate.jpg?w=1920&format=webp";
import lcp_solar_pv_why_generate from "@/assets/solar-pv/why-generate.jpg?w=1920&format=avif";

import meta_stock_photo_1473773508845_188df298d2d1 from "@/assets/stock/photo-1473773508845-188df298d2d1.jpg?as=metadata";
import avif_stock_photo_1473773508845_188df298d2d1 from "@/assets/stock/photo-1473773508845-188df298d2d1.jpg?w=640;1024;1920&format=avif&as=srcset";
import webp_stock_photo_1473773508845_188df298d2d1 from "@/assets/stock/photo-1473773508845-188df298d2d1.jpg?w=640;1024;1920&format=webp&as=srcset";
import fallback_stock_photo_1473773508845_188df298d2d1 from "@/assets/stock/photo-1473773508845-188df298d2d1.jpg?w=1920&format=webp";
import lcp_stock_photo_1473773508845_188df298d2d1 from "@/assets/stock/photo-1473773508845-188df298d2d1.jpg?w=1920&format=avif";

import meta_stock_photo_1497366216548_37526070297c from "@/assets/stock/photo-1497366216548-37526070297c.jpg?as=metadata";
import avif_stock_photo_1497366216548_37526070297c from "@/assets/stock/photo-1497366216548-37526070297c.jpg?w=640;1024;1920&format=avif&as=srcset";
import webp_stock_photo_1497366216548_37526070297c from "@/assets/stock/photo-1497366216548-37526070297c.jpg?w=640;1024;1920&format=webp&as=srcset";
import fallback_stock_photo_1497366216548_37526070297c from "@/assets/stock/photo-1497366216548-37526070297c.jpg?w=1920&format=webp";
import lcp_stock_photo_1497366216548_37526070297c from "@/assets/stock/photo-1497366216548-37526070297c.jpg?w=1920&format=avif";

import meta_stock_photo_1497440001374_f26997328c1b from "@/assets/stock/photo-1497440001374-f26997328c1b.jpg?as=metadata";
import avif_stock_photo_1497440001374_f26997328c1b from "@/assets/stock/photo-1497440001374-f26997328c1b.jpg?w=640;1024;1920&format=avif&as=srcset";
import webp_stock_photo_1497440001374_f26997328c1b from "@/assets/stock/photo-1497440001374-f26997328c1b.jpg?w=640;1024;1920&format=webp&as=srcset";
import fallback_stock_photo_1497440001374_f26997328c1b from "@/assets/stock/photo-1497440001374-f26997328c1b.jpg?w=1920&format=webp";
import lcp_stock_photo_1497440001374_f26997328c1b from "@/assets/stock/photo-1497440001374-f26997328c1b.jpg?w=1920&format=avif";

import meta_stock_photo_1503387762_592deb58ef4e from "@/assets/stock/photo-1503387762-592deb58ef4e.jpg?as=metadata";
import avif_stock_photo_1503387762_592deb58ef4e from "@/assets/stock/photo-1503387762-592deb58ef4e.jpg?w=640;1024;1920&format=avif&as=srcset";
import webp_stock_photo_1503387762_592deb58ef4e from "@/assets/stock/photo-1503387762-592deb58ef4e.jpg?w=640;1024;1920&format=webp&as=srcset";
import fallback_stock_photo_1503387762_592deb58ef4e from "@/assets/stock/photo-1503387762-592deb58ef4e.jpg?w=1920&format=webp";
import lcp_stock_photo_1503387762_592deb58ef4e from "@/assets/stock/photo-1503387762-592deb58ef4e.jpg?w=1920&format=avif";

import meta_stock_photo_1558002038_1055907df827 from "@/assets/stock/photo-1558002038-1055907df827.jpg?as=metadata";
import avif_stock_photo_1558002038_1055907df827 from "@/assets/stock/photo-1558002038-1055907df827.jpg?w=640;1024;1920&format=avif&as=srcset";
import webp_stock_photo_1558002038_1055907df827 from "@/assets/stock/photo-1558002038-1055907df827.jpg?w=640;1024;1920&format=webp&as=srcset";
import fallback_stock_photo_1558002038_1055907df827 from "@/assets/stock/photo-1558002038-1055907df827.jpg?w=1920&format=webp";
import lcp_stock_photo_1558002038_1055907df827 from "@/assets/stock/photo-1558002038-1055907df827.jpg?w=1920&format=avif";

import meta_stock_photo_1559526324_4b87b5e36e44 from "@/assets/stock/photo-1559526324-4b87b5e36e44.jpg?as=metadata";
import avif_stock_photo_1559526324_4b87b5e36e44 from "@/assets/stock/photo-1559526324-4b87b5e36e44.jpg?w=640;1024;1920&format=avif&as=srcset";
import webp_stock_photo_1559526324_4b87b5e36e44 from "@/assets/stock/photo-1559526324-4b87b5e36e44.jpg?w=640;1024;1920&format=webp&as=srcset";
import fallback_stock_photo_1559526324_4b87b5e36e44 from "@/assets/stock/photo-1559526324-4b87b5e36e44.jpg?w=1920&format=webp";
import lcp_stock_photo_1559526324_4b87b5e36e44 from "@/assets/stock/photo-1559526324-4b87b5e36e44.jpg?w=1920&format=avif";

import meta_stock_photo_1560185007_cde436f6a4d0 from "@/assets/stock/photo-1560185007-cde436f6a4d0.jpg?as=metadata";
import avif_stock_photo_1560185007_cde436f6a4d0 from "@/assets/stock/photo-1560185007-cde436f6a4d0.jpg?w=640;1024;1920&format=avif&as=srcset";
import webp_stock_photo_1560185007_cde436f6a4d0 from "@/assets/stock/photo-1560185007-cde436f6a4d0.jpg?w=640;1024;1920&format=webp&as=srcset";
import fallback_stock_photo_1560185007_cde436f6a4d0 from "@/assets/stock/photo-1560185007-cde436f6a4d0.jpg?w=1920&format=webp";
import lcp_stock_photo_1560185007_cde436f6a4d0 from "@/assets/stock/photo-1560185007-cde436f6a4d0.jpg?w=1920&format=avif";

import meta_stock_photo_1573164574511_73c773193279 from "@/assets/stock/photo-1573164574511-73c773193279.jpg?as=metadata";
import avif_stock_photo_1573164574511_73c773193279 from "@/assets/stock/photo-1573164574511-73c773193279.jpg?w=640;1024;1920&format=avif&as=srcset";
import webp_stock_photo_1573164574511_73c773193279 from "@/assets/stock/photo-1573164574511-73c773193279.jpg?w=640;1024;1920&format=webp&as=srcset";
import fallback_stock_photo_1573164574511_73c773193279 from "@/assets/stock/photo-1573164574511-73c773193279.jpg?w=1920&format=webp";
import lcp_stock_photo_1573164574511_73c773193279 from "@/assets/stock/photo-1573164574511-73c773193279.jpg?w=1920&format=avif";

import meta_stock_photo_1581094288338_2314dddb7ece from "@/assets/stock/photo-1581094288338-2314dddb7ece.jpg?as=metadata";
import avif_stock_photo_1581094288338_2314dddb7ece from "@/assets/stock/photo-1581094288338-2314dddb7ece.jpg?w=640;1024;1920&format=avif&as=srcset";
import webp_stock_photo_1581094288338_2314dddb7ece from "@/assets/stock/photo-1581094288338-2314dddb7ece.jpg?w=640;1024;1920&format=webp&as=srcset";
import fallback_stock_photo_1581094288338_2314dddb7ece from "@/assets/stock/photo-1581094288338-2314dddb7ece.jpg?w=1920&format=webp";
import lcp_stock_photo_1581094288338_2314dddb7ece from "@/assets/stock/photo-1581094288338-2314dddb7ece.jpg?w=1920&format=avif";

import meta_stock_photo_1582407947304_fd86f028f716 from "@/assets/stock/photo-1582407947304-fd86f028f716.jpg?as=metadata";
import avif_stock_photo_1582407947304_fd86f028f716 from "@/assets/stock/photo-1582407947304-fd86f028f716.jpg?w=640;1024;1920&format=avif&as=srcset";
import webp_stock_photo_1582407947304_fd86f028f716 from "@/assets/stock/photo-1582407947304-fd86f028f716.jpg?w=640;1024;1920&format=webp&as=srcset";
import fallback_stock_photo_1582407947304_fd86f028f716 from "@/assets/stock/photo-1582407947304-fd86f028f716.jpg?w=1920&format=webp";
import lcp_stock_photo_1582407947304_fd86f028f716 from "@/assets/stock/photo-1582407947304-fd86f028f716.jpg?w=1920&format=avif";

export const RASTER_IMAGES = {
  "air-source-heat-pumps/ashp-card-cylinder": {
    id: "air-source-heat-pumps/ashp-card-cylinder",
    width: meta_air_source_heat_pumps_ashp_card_cylinder.width ?? 1536,
    height: meta_air_source_heat_pumps_ashp_card_cylinder.height ?? 1024,
    avifSrcSet: avif_air_source_heat_pumps_ashp_card_cylinder,
    webpSrcSet: webp_air_source_heat_pumps_ashp_card_cylinder,
    fallback: fallback_air_source_heat_pumps_ashp_card_cylinder,
    lcpAvif: lcp_air_source_heat_pumps_ashp_card_cylinder,
  },
  "air-source-heat-pumps/ashp-card-electrics": {
    id: "air-source-heat-pumps/ashp-card-electrics",
    width: meta_air_source_heat_pumps_ashp_card_electrics.width ?? 1536,
    height: meta_air_source_heat_pumps_ashp_card_electrics.height ?? 1024,
    avifSrcSet: avif_air_source_heat_pumps_ashp_card_electrics,
    webpSrcSet: webp_air_source_heat_pumps_ashp_card_electrics,
    fallback: fallback_air_source_heat_pumps_ashp_card_electrics,
    lcpAvif: lcp_air_source_heat_pumps_ashp_card_electrics,
  },
  "air-source-heat-pumps/ashp-card-emitters": {
    id: "air-source-heat-pumps/ashp-card-emitters",
    width: meta_air_source_heat_pumps_ashp_card_emitters.width ?? 1536,
    height: meta_air_source_heat_pumps_ashp_card_emitters.height ?? 1024,
    avifSrcSet: avif_air_source_heat_pumps_ashp_card_emitters,
    webpSrcSet: webp_air_source_heat_pumps_ashp_card_emitters,
    fallback: fallback_air_source_heat_pumps_ashp_card_emitters,
    lcpAvif: lcp_air_source_heat_pumps_ashp_card_emitters,
  },
  "air-source-heat-pumps/ashp-card-fabric": {
    id: "air-source-heat-pumps/ashp-card-fabric",
    width: meta_air_source_heat_pumps_ashp_card_fabric.width ?? 1536,
    height: meta_air_source_heat_pumps_ashp_card_fabric.height ?? 1024,
    avifSrcSet: avif_air_source_heat_pumps_ashp_card_fabric,
    webpSrcSet: webp_air_source_heat_pumps_ashp_card_fabric,
    fallback: fallback_air_source_heat_pumps_ashp_card_fabric,
    lcpAvif: lcp_air_source_heat_pumps_ashp_card_fabric,
  },
  "air-source-heat-pumps/ashp-card-heatloss": {
    id: "air-source-heat-pumps/ashp-card-heatloss",
    width: meta_air_source_heat_pumps_ashp_card_heatloss.width ?? 1536,
    height: meta_air_source_heat_pumps_ashp_card_heatloss.height ?? 1024,
    avifSrcSet: avif_air_source_heat_pumps_ashp_card_heatloss,
    webpSrcSet: webp_air_source_heat_pumps_ashp_card_heatloss,
    fallback: fallback_air_source_heat_pumps_ashp_card_heatloss,
    lcpAvif: lcp_air_source_heat_pumps_ashp_card_heatloss,
  },
  "air-source-heat-pumps/ashp-card-siting": {
    id: "air-source-heat-pumps/ashp-card-siting",
    width: meta_air_source_heat_pumps_ashp_card_siting.width ?? 1536,
    height: meta_air_source_heat_pumps_ashp_card_siting.height ?? 1024,
    avifSrcSet: avif_air_source_heat_pumps_ashp_card_siting,
    webpSrcSet: webp_air_source_heat_pumps_ashp_card_siting,
    fallback: fallback_air_source_heat_pumps_ashp_card_siting,
    lcpAvif: lcp_air_source_heat_pumps_ashp_card_siting,
  },
  "air-source-heat-pumps/ashp-evidence": {
    id: "air-source-heat-pumps/ashp-evidence",
    width: meta_air_source_heat_pumps_ashp_evidence.width ?? 1536,
    height: meta_air_source_heat_pumps_ashp_evidence.height ?? 1024,
    avifSrcSet: avif_air_source_heat_pumps_ashp_evidence,
    webpSrcSet: webp_air_source_heat_pumps_ashp_evidence,
    fallback: fallback_air_source_heat_pumps_ashp_evidence,
    lcpAvif: lcp_air_source_heat_pumps_ashp_evidence,
  },
  "air-source-heat-pumps/ashp-handover-pack": {
    id: "air-source-heat-pumps/ashp-handover-pack",
    width: meta_air_source_heat_pumps_ashp_handover_pack.width ?? 1536,
    height: meta_air_source_heat_pumps_ashp_handover_pack.height ?? 1024,
    avifSrcSet: avif_air_source_heat_pumps_ashp_handover_pack,
    webpSrcSet: webp_air_source_heat_pumps_ashp_handover_pack,
    fallback: fallback_air_source_heat_pumps_ashp_handover_pack,
    lcpAvif: lcp_air_source_heat_pumps_ashp_handover_pack,
  },
  "air-source-heat-pumps/ashp-step-1": {
    id: "air-source-heat-pumps/ashp-step-1",
    width: meta_air_source_heat_pumps_ashp_step_1.width ?? 1536,
    height: meta_air_source_heat_pumps_ashp_step_1.height ?? 1024,
    avifSrcSet: avif_air_source_heat_pumps_ashp_step_1,
    webpSrcSet: webp_air_source_heat_pumps_ashp_step_1,
    fallback: fallback_air_source_heat_pumps_ashp_step_1,
    lcpAvif: lcp_air_source_heat_pumps_ashp_step_1,
  },
  "air-source-heat-pumps/ashp-step-2": {
    id: "air-source-heat-pumps/ashp-step-2",
    width: meta_air_source_heat_pumps_ashp_step_2.width ?? 1536,
    height: meta_air_source_heat_pumps_ashp_step_2.height ?? 1024,
    avifSrcSet: avif_air_source_heat_pumps_ashp_step_2,
    webpSrcSet: webp_air_source_heat_pumps_ashp_step_2,
    fallback: fallback_air_source_heat_pumps_ashp_step_2,
    lcpAvif: lcp_air_source_heat_pumps_ashp_step_2,
  },
  "air-source-heat-pumps/ashp-step-3": {
    id: "air-source-heat-pumps/ashp-step-3",
    width: meta_air_source_heat_pumps_ashp_step_3.width ?? 1536,
    height: meta_air_source_heat_pumps_ashp_step_3.height ?? 1024,
    avifSrcSet: avif_air_source_heat_pumps_ashp_step_3,
    webpSrcSet: webp_air_source_heat_pumps_ashp_step_3,
    fallback: fallback_air_source_heat_pumps_ashp_step_3,
    lcpAvif: lcp_air_source_heat_pumps_ashp_step_3,
  },
  "air-source-heat-pumps/ashp-step-4": {
    id: "air-source-heat-pumps/ashp-step-4",
    width: meta_air_source_heat_pumps_ashp_step_4.width ?? 1536,
    height: meta_air_source_heat_pumps_ashp_step_4.height ?? 1024,
    avifSrcSet: avif_air_source_heat_pumps_ashp_step_4,
    webpSrcSet: webp_air_source_heat_pumps_ashp_step_4,
    fallback: fallback_air_source_heat_pumps_ashp_step_4,
    lcpAvif: lcp_air_source_heat_pumps_ashp_step_4,
  },
  "boiler-upgrade-scheme/bus-grant-journey": {
    id: "boiler-upgrade-scheme/bus-grant-journey",
    width: meta_boiler_upgrade_scheme_bus_grant_journey.width ?? 1024,
    height: meta_boiler_upgrade_scheme_bus_grant_journey.height ?? 1536,
    avifSrcSet: avif_boiler_upgrade_scheme_bus_grant_journey,
    webpSrcSet: webp_boiler_upgrade_scheme_bus_grant_journey,
    fallback: fallback_boiler_upgrade_scheme_bus_grant_journey,
    lcpAvif: lcp_boiler_upgrade_scheme_bus_grant_journey,
  },
  "brands/hgc-logo": {
    id: "brands/hgc-logo",
    width: meta_brands_hgc_logo.width ?? 160,
    height: meta_brands_hgc_logo.height ?? 96,
    avifSrcSet: avif_brands_hgc_logo,
    webpSrcSet: webp_brands_hgc_logo,
    fallback: fallback_brands_hgc_logo,
    lcpAvif: lcp_brands_hgc_logo,
  },
  "commercial-damp-mould-ventilation/hero-commercial-damp-mould": {
    id: "commercial-damp-mould-ventilation/hero-commercial-damp-mould",
    width: meta_commercial_damp_mould_ventilation_hero_commercial_damp_mould.width ?? 1280,
    height: meta_commercial_damp_mould_ventilation_hero_commercial_damp_mould.height ?? 720,
    avifSrcSet: avif_commercial_damp_mould_ventilation_hero_commercial_damp_mould,
    webpSrcSet: webp_commercial_damp_mould_ventilation_hero_commercial_damp_mould,
    fallback: fallback_commercial_damp_mould_ventilation_hero_commercial_damp_mould,
    lcpAvif: lcp_commercial_damp_mould_ventilation_hero_commercial_damp_mould,
  },
  "commercial-solar-pv/hero-commercial-solar": {
    id: "commercial-solar-pv/hero-commercial-solar",
    width: meta_commercial_solar_pv_hero_commercial_solar.width ?? 1920,
    height: meta_commercial_solar_pv_hero_commercial_solar.height ?? 1280,
    avifSrcSet: avif_commercial_solar_pv_hero_commercial_solar,
    webpSrcSet: webp_commercial_solar_pv_hero_commercial_solar,
    fallback: fallback_commercial_solar_pv_hero_commercial_solar,
    lcpAvif: lcp_commercial_solar_pv_hero_commercial_solar,
  },
  "damp-survey/damp-condensation": {
    id: "damp-survey/damp-condensation",
    width: meta_damp_survey_damp_condensation.width ?? 1280,
    height: meta_damp_survey_damp_condensation.height ?? 720,
    avifSrcSet: avif_damp_survey_damp_condensation,
    webpSrcSet: webp_damp_survey_damp_condensation,
    fallback: fallback_damp_survey_damp_condensation,
    lcpAvif: lcp_damp_survey_damp_condensation,
  },
  "damp-survey/damp-penetrating": {
    id: "damp-survey/damp-penetrating",
    width: meta_damp_survey_damp_penetrating.width ?? 1280,
    height: meta_damp_survey_damp_penetrating.height ?? 720,
    avifSrcSet: avif_damp_survey_damp_penetrating,
    webpSrcSet: webp_damp_survey_damp_penetrating,
    fallback: fallback_damp_survey_damp_penetrating,
    lcpAvif: lcp_damp_survey_damp_penetrating,
  },
  "damp-survey/damp-rising": {
    id: "damp-survey/damp-rising",
    width: meta_damp_survey_damp_rising.width ?? 1280,
    height: meta_damp_survey_damp_rising.height ?? 720,
    avifSrcSet: avif_damp_survey_damp_rising,
    webpSrcSet: webp_damp_survey_damp_rising,
    fallback: fallback_damp_survey_damp_rising,
    lcpAvif: lcp_damp_survey_damp_rising,
  },
  "damp-survey/services/breathable-wall-moisture-control": {
    id: "damp-survey/services/breathable-wall-moisture-control",
    width: meta_damp_survey_services_breathable_wall_moisture_control.width ?? 1280,
    height: meta_damp_survey_services_breathable_wall_moisture_control.height ?? 720,
    avifSrcSet: avif_damp_survey_services_breathable_wall_moisture_control,
    webpSrcSet: webp_damp_survey_services_breathable_wall_moisture_control,
    fallback: fallback_damp_survey_services_breathable_wall_moisture_control,
    lcpAvif: lcp_damp_survey_services_breathable_wall_moisture_control,
  },
  "damp-survey/services/cavity-insulation-assessment": {
    id: "damp-survey/services/cavity-insulation-assessment",
    width: meta_damp_survey_services_cavity_insulation_assessment.width ?? 608,
    height: meta_damp_survey_services_cavity_insulation_assessment.height ?? 1080,
    avifSrcSet: avif_damp_survey_services_cavity_insulation_assessment,
    webpSrcSet: webp_damp_survey_services_cavity_insulation_assessment,
    fallback: fallback_damp_survey_services_cavity_insulation_assessment,
    lcpAvif: lcp_damp_survey_services_cavity_insulation_assessment,
  },
  "damp-survey/services/controlled-ventilation-air-quality": {
    id: "damp-survey/services/controlled-ventilation-air-quality",
    width: meta_damp_survey_services_controlled_ventilation_air_quality.width ?? 1280,
    height: meta_damp_survey_services_controlled_ventilation_air_quality.height ?? 720,
    avifSrcSet: avif_damp_survey_services_controlled_ventilation_air_quality,
    webpSrcSet: webp_damp_survey_services_controlled_ventilation_air_quality,
    fallback: fallback_damp_survey_services_controlled_ventilation_air_quality,
    lcpAvif: lcp_damp_survey_services_controlled_ventilation_air_quality,
  },
  "damp-survey/services/external-repairs-management": {
    id: "damp-survey/services/external-repairs-management",
    width: meta_damp_survey_services_external_repairs_management.width ?? 1672,
    height: meta_damp_survey_services_external_repairs_management.height ?? 941,
    avifSrcSet: avif_damp_survey_services_external_repairs_management,
    webpSrcSet: webp_damp_survey_services_external_repairs_management,
    fallback: fallback_damp_survey_services_external_repairs_management,
    lcpAvif: lcp_damp_survey_services_external_repairs_management,
  },
  "damp-survey/services/structural-penetrating-damp": {
    id: "damp-survey/services/structural-penetrating-damp",
    width: meta_damp_survey_services_structural_penetrating_damp.width ?? 1536,
    height: meta_damp_survey_services_structural_penetrating_damp.height ?? 1024,
    avifSrcSet: avif_damp_survey_services_structural_penetrating_damp,
    webpSrcSet: webp_damp_survey_services_structural_penetrating_damp,
    fallback: fallback_damp_survey_services_structural_penetrating_damp,
    lcpAvif: lcp_damp_survey_services_structural_penetrating_damp,
  },
  "financing/ideal4finance-partner-banner": {
    id: "financing/ideal4finance-partner-banner",
    width: meta_financing_ideal4finance_partner_banner.width ?? 1024,
    height: meta_financing_ideal4finance_partner_banner.height ?? 256,
    avifSrcSet: avif_financing_ideal4finance_partner_banner,
    webpSrcSet: webp_financing_ideal4finance_partner_banner,
    fallback: fallback_financing_ideal4finance_partner_banner,
    lcpAvif: lcp_financing_ideal4finance_partner_banner,
  },
  "solar-pv/hero-solar": {
    id: "solar-pv/hero-solar",
    width: meta_solar_pv_hero_solar.width ?? 1920,
    height: meta_solar_pv_hero_solar.height ?? 1280,
    avifSrcSet: avif_solar_pv_hero_solar,
    webpSrcSet: webp_solar_pv_hero_solar,
    fallback: fallback_solar_pv_hero_solar,
    lcpAvif: lcp_solar_pv_hero_solar,
  },
  "solar-pv/solar-assessment-roof": {
    id: "solar-pv/solar-assessment-roof",
    width: meta_solar_pv_solar_assessment_roof.width ?? 1024,
    height: meta_solar_pv_solar_assessment_roof.height ?? 819,
    avifSrcSet: avif_solar_pv_solar_assessment_roof,
    webpSrcSet: webp_solar_pv_solar_assessment_roof,
    fallback: fallback_solar_pv_solar_assessment_roof,
    lcpAvif: lcp_solar_pv_solar_assessment_roof,
  },
  "solar-pv/solar-card-battery": {
    id: "solar-pv/solar-card-battery",
    width: meta_solar_pv_solar_card_battery.width ?? 1024,
    height: meta_solar_pv_solar_card_battery.height ?? 1024,
    avifSrcSet: avif_solar_pv_solar_card_battery,
    webpSrcSet: webp_solar_pv_solar_card_battery,
    fallback: fallback_solar_pv_solar_card_battery,
    lcpAvif: lcp_solar_pv_solar_card_battery,
  },
  "solar-pv/solar-card-dno": {
    id: "solar-pv/solar-card-dno",
    width: meta_solar_pv_solar_card_dno.width ?? 1024,
    height: meta_solar_pv_solar_card_dno.height ?? 1024,
    avifSrcSet: avif_solar_pv_solar_card_dno,
    webpSrcSet: webp_solar_pv_solar_card_dno,
    fallback: fallback_solar_pv_solar_card_dno,
    lcpAvif: lcp_solar_pv_solar_card_dno,
  },
  "solar-pv/solar-card-electrics": {
    id: "solar-pv/solar-card-electrics",
    width: meta_solar_pv_solar_card_electrics.width ?? 1024,
    height: meta_solar_pv_solar_card_electrics.height ?? 1024,
    avifSrcSet: avif_solar_pv_solar_card_electrics,
    webpSrcSet: webp_solar_pv_solar_card_electrics,
    fallback: fallback_solar_pv_solar_card_electrics,
    lcpAvif: lcp_solar_pv_solar_card_electrics,
  },
  "solar-pv/solar-card-monitoring": {
    id: "solar-pv/solar-card-monitoring",
    width: meta_solar_pv_solar_card_monitoring.width ?? 1024,
    height: meta_solar_pv_solar_card_monitoring.height ?? 1024,
    avifSrcSet: avif_solar_pv_solar_card_monitoring,
    webpSrcSet: webp_solar_pv_solar_card_monitoring,
    fallback: fallback_solar_pv_solar_card_monitoring,
    lcpAvif: lcp_solar_pv_solar_card_monitoring,
  },
  "solar-pv/solar-card-orientation": {
    id: "solar-pv/solar-card-orientation",
    width: meta_solar_pv_solar_card_orientation.width ?? 1024,
    height: meta_solar_pv_solar_card_orientation.height ?? 1024,
    avifSrcSet: avif_solar_pv_solar_card_orientation,
    webpSrcSet: webp_solar_pv_solar_card_orientation,
    fallback: fallback_solar_pv_solar_card_orientation,
    lcpAvif: lcp_solar_pv_solar_card_orientation,
  },
  "solar-pv/solar-card-roof": {
    id: "solar-pv/solar-card-roof",
    width: meta_solar_pv_solar_card_roof.width ?? 1024,
    height: meta_solar_pv_solar_card_roof.height ?? 1024,
    avifSrcSet: avif_solar_pv_solar_card_roof,
    webpSrcSet: webp_solar_pv_solar_card_roof,
    fallback: fallback_solar_pv_solar_card_roof,
    lcpAvif: lcp_solar_pv_solar_card_roof,
  },
  "solar-pv/solar-evidence": {
    id: "solar-pv/solar-evidence",
    width: meta_solar_pv_solar_evidence.width ?? 1200,
    height: meta_solar_pv_solar_evidence.height ?? 800,
    avifSrcSet: avif_solar_pv_solar_evidence,
    webpSrcSet: webp_solar_pv_solar_evidence,
    fallback: fallback_solar_pv_solar_evidence,
    lcpAvif: lcp_solar_pv_solar_evidence,
  },
  "solar-pv/solar-handover-pack": {
    id: "solar-pv/solar-handover-pack",
    width: meta_solar_pv_solar_handover_pack.width ?? 1024,
    height: meta_solar_pv_solar_handover_pack.height ?? 768,
    avifSrcSet: avif_solar_pv_solar_handover_pack,
    webpSrcSet: webp_solar_pv_solar_handover_pack,
    fallback: fallback_solar_pv_solar_handover_pack,
    lcpAvif: lcp_solar_pv_solar_handover_pack,
  },
  "solar-pv/solar-step-1": {
    id: "solar-pv/solar-step-1",
    width: meta_solar_pv_solar_step_1.width ?? 1024,
    height: meta_solar_pv_solar_step_1.height ?? 1024,
    avifSrcSet: avif_solar_pv_solar_step_1,
    webpSrcSet: webp_solar_pv_solar_step_1,
    fallback: fallback_solar_pv_solar_step_1,
    lcpAvif: lcp_solar_pv_solar_step_1,
  },
  "solar-pv/solar-step-2": {
    id: "solar-pv/solar-step-2",
    width: meta_solar_pv_solar_step_2.width ?? 1024,
    height: meta_solar_pv_solar_step_2.height ?? 1024,
    avifSrcSet: avif_solar_pv_solar_step_2,
    webpSrcSet: webp_solar_pv_solar_step_2,
    fallback: fallback_solar_pv_solar_step_2,
    lcpAvif: lcp_solar_pv_solar_step_2,
  },
  "solar-pv/solar-step-3": {
    id: "solar-pv/solar-step-3",
    width: meta_solar_pv_solar_step_3.width ?? 1024,
    height: meta_solar_pv_solar_step_3.height ?? 1024,
    avifSrcSet: avif_solar_pv_solar_step_3,
    webpSrcSet: webp_solar_pv_solar_step_3,
    fallback: fallback_solar_pv_solar_step_3,
    lcpAvif: lcp_solar_pv_solar_step_3,
  },
  "solar-pv/why-battery": {
    id: "solar-pv/why-battery",
    width: meta_solar_pv_why_battery.width ?? 1280,
    height: meta_solar_pv_why_battery.height ?? 960,
    avifSrcSet: avif_solar_pv_why_battery,
    webpSrcSet: webp_solar_pv_why_battery,
    fallback: fallback_solar_pv_why_battery,
    lcpAvif: lcp_solar_pv_why_battery,
  },
  "solar-pv/why-designed-customer": {
    id: "solar-pv/why-designed-customer",
    width: meta_solar_pv_why_designed_customer.width ?? 971,
    height: meta_solar_pv_why_designed_customer.height ?? 1024,
    avifSrcSet: avif_solar_pv_why_designed_customer,
    webpSrcSet: webp_solar_pv_why_designed_customer,
    fallback: fallback_solar_pv_why_designed_customer,
    lcpAvif: lcp_solar_pv_why_designed_customer,
  },
  "solar-pv/why-designed": {
    id: "solar-pv/why-designed",
    width: meta_solar_pv_why_designed.width ?? 1280,
    height: meta_solar_pv_why_designed.height ?? 960,
    avifSrcSet: avif_solar_pv_why_designed,
    webpSrcSet: webp_solar_pv_why_designed,
    fallback: fallback_solar_pv_why_designed,
    lcpAvif: lcp_solar_pv_why_designed,
  },
  "solar-pv/why-export": {
    id: "solar-pv/why-export",
    width: meta_solar_pv_why_export.width ?? 1280,
    height: meta_solar_pv_why_export.height ?? 960,
    avifSrcSet: avif_solar_pv_why_export,
    webpSrcSet: webp_solar_pv_why_export,
    fallback: fallback_solar_pv_why_export,
    lcpAvif: lcp_solar_pv_why_export,
  },
  "solar-pv/why-generate": {
    id: "solar-pv/why-generate",
    width: meta_solar_pv_why_generate.width ?? 1280,
    height: meta_solar_pv_why_generate.height ?? 960,
    avifSrcSet: avif_solar_pv_why_generate,
    webpSrcSet: webp_solar_pv_why_generate,
    fallback: fallback_solar_pv_why_generate,
    lcpAvif: lcp_solar_pv_why_generate,
  },
  "stock/photo-1473773508845-188df298d2d1": {
    id: "stock/photo-1473773508845-188df298d2d1",
    width: meta_stock_photo_1473773508845_188df298d2d1.width ?? 1920,
    height: meta_stock_photo_1473773508845_188df298d2d1.height ?? 1440,
    avifSrcSet: avif_stock_photo_1473773508845_188df298d2d1,
    webpSrcSet: webp_stock_photo_1473773508845_188df298d2d1,
    fallback: fallback_stock_photo_1473773508845_188df298d2d1,
    lcpAvif: lcp_stock_photo_1473773508845_188df298d2d1,
  },
  "stock/photo-1497366216548-37526070297c": {
    id: "stock/photo-1497366216548-37526070297c",
    width: meta_stock_photo_1497366216548_37526070297c.width ?? 1920,
    height: meta_stock_photo_1497366216548_37526070297c.height ?? 1282,
    avifSrcSet: avif_stock_photo_1497366216548_37526070297c,
    webpSrcSet: webp_stock_photo_1497366216548_37526070297c,
    fallback: fallback_stock_photo_1497366216548_37526070297c,
    lcpAvif: lcp_stock_photo_1497366216548_37526070297c,
  },
  "stock/photo-1497440001374-f26997328c1b": {
    id: "stock/photo-1497440001374-f26997328c1b",
    width: meta_stock_photo_1497440001374_f26997328c1b.width ?? 1920,
    height: meta_stock_photo_1497440001374_f26997328c1b.height ?? 1080,
    avifSrcSet: avif_stock_photo_1497440001374_f26997328c1b,
    webpSrcSet: webp_stock_photo_1497440001374_f26997328c1b,
    fallback: fallback_stock_photo_1497440001374_f26997328c1b,
    lcpAvif: lcp_stock_photo_1497440001374_f26997328c1b,
  },
  "stock/photo-1503387762-592deb58ef4e": {
    id: "stock/photo-1503387762-592deb58ef4e",
    width: meta_stock_photo_1503387762_592deb58ef4e.width ?? 1920,
    height: meta_stock_photo_1503387762_592deb58ef4e.height ?? 1080,
    avifSrcSet: avif_stock_photo_1503387762_592deb58ef4e,
    webpSrcSet: webp_stock_photo_1503387762_592deb58ef4e,
    fallback: fallback_stock_photo_1503387762_592deb58ef4e,
    lcpAvif: lcp_stock_photo_1503387762_592deb58ef4e,
  },
  "stock/photo-1558002038-1055907df827": {
    id: "stock/photo-1558002038-1055907df827",
    width: meta_stock_photo_1558002038_1055907df827.width ?? 1920,
    height: meta_stock_photo_1558002038_1055907df827.height ?? 1280,
    avifSrcSet: avif_stock_photo_1558002038_1055907df827,
    webpSrcSet: webp_stock_photo_1558002038_1055907df827,
    fallback: fallback_stock_photo_1558002038_1055907df827,
    lcpAvif: lcp_stock_photo_1558002038_1055907df827,
  },
  "stock/photo-1559526324-4b87b5e36e44": {
    id: "stock/photo-1559526324-4b87b5e36e44",
    width: meta_stock_photo_1559526324_4b87b5e36e44.width ?? 1920,
    height: meta_stock_photo_1559526324_4b87b5e36e44.height ?? 1280,
    avifSrcSet: avif_stock_photo_1559526324_4b87b5e36e44,
    webpSrcSet: webp_stock_photo_1559526324_4b87b5e36e44,
    fallback: fallback_stock_photo_1559526324_4b87b5e36e44,
    lcpAvif: lcp_stock_photo_1559526324_4b87b5e36e44,
  },
  "stock/photo-1560185007-cde436f6a4d0": {
    id: "stock/photo-1560185007-cde436f6a4d0",
    width: meta_stock_photo_1560185007_cde436f6a4d0.width ?? 1920,
    height: meta_stock_photo_1560185007_cde436f6a4d0.height ?? 1280,
    avifSrcSet: avif_stock_photo_1560185007_cde436f6a4d0,
    webpSrcSet: webp_stock_photo_1560185007_cde436f6a4d0,
    fallback: fallback_stock_photo_1560185007_cde436f6a4d0,
    lcpAvif: lcp_stock_photo_1560185007_cde436f6a4d0,
  },
  "stock/photo-1573164574511-73c773193279": {
    id: "stock/photo-1573164574511-73c773193279",
    width: meta_stock_photo_1573164574511_73c773193279.width ?? 1920,
    height: meta_stock_photo_1573164574511_73c773193279.height ?? 1282,
    avifSrcSet: avif_stock_photo_1573164574511_73c773193279,
    webpSrcSet: webp_stock_photo_1573164574511_73c773193279,
    fallback: fallback_stock_photo_1573164574511_73c773193279,
    lcpAvif: lcp_stock_photo_1573164574511_73c773193279,
  },
  "stock/photo-1581094288338-2314dddb7ece": {
    id: "stock/photo-1581094288338-2314dddb7ece",
    width: meta_stock_photo_1581094288338_2314dddb7ece.width ?? 1920,
    height: meta_stock_photo_1581094288338_2314dddb7ece.height ?? 1281,
    avifSrcSet: avif_stock_photo_1581094288338_2314dddb7ece,
    webpSrcSet: webp_stock_photo_1581094288338_2314dddb7ece,
    fallback: fallback_stock_photo_1581094288338_2314dddb7ece,
    lcpAvif: lcp_stock_photo_1581094288338_2314dddb7ece,
  },
  "stock/photo-1582407947304-fd86f028f716": {
    id: "stock/photo-1582407947304-fd86f028f716",
    width: meta_stock_photo_1582407947304_fd86f028f716.width ?? 1920,
    height: meta_stock_photo_1582407947304_fd86f028f716.height ?? 1118,
    avifSrcSet: avif_stock_photo_1582407947304_fd86f028f716,
    webpSrcSet: webp_stock_photo_1582407947304_fd86f028f716,
    fallback: fallback_stock_photo_1582407947304_fd86f028f716,
    lcpAvif: lcp_stock_photo_1582407947304_fd86f028f716,
  },
} as const satisfies Record<string, RasterImageSet>;

export type RasterImageId = keyof typeof RASTER_IMAGES;

export function getRasterImage(id: RasterImageId): RasterImageSet {
  return RASTER_IMAGES[id];
}

export function rasterSrc(id: RasterImageId): string {
  return RASTER_IMAGES[id].fallback;
}
